module.exports = __webpack_public_path__ + "front/img/10_2.4dffe263.png";